














































































import ActionButton from '@/components/ActionButton.vue'
import AgencyCreateDialog from '@/components/Agency/Daughters/AgencyCreateDialog.vue'
import Table from '@/components/Table.vue'
import { getAgencies, getAgencyById } from '@/api/Agency/agency.api'
import { Agency } from '@/api/Agency/agency.interface'
import { tableHandler } from '@/utils/mixins/tableHandler'
import TransferDialog from '@/components/Agency/Daughters/TransferDialog.vue'
import AgencyFilter from '@/components/Agency/Daughters/AgencyFilter.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler<Agency>().extend({
  components: {
    appActionButton: ActionButton,
    appAgencyCreateDialog: AgencyCreateDialog,
    appTable: Table,
    appTransferDialog: TransferDialog,
    AgencyFilter,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      filterModel: false,
      dialogModel: false,
      getter: getAgencies,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('address'),
          value: 'full_address',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: this.$t('services'),
          value: 'services',
        },
        {
          text: this.$t('balance'),
          value: 'balance',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
      transferItem: null as null | Agency,
      transferDialog: false,
    }
  },
  methods: {
    editAgency(item: Agency) {
      const agency = {
        ...item,
        address: item.address || {
          address_1: '',
          address_2: '',
        },
      }
      this.onEdit(agency)
    },
    onTransfer(item: Agency) {
      this.transferItem = item
      this.transferDialog = true
    },
  },
  async mounted() {
    const response = await getAgencyById(this.$store.getters.profile.agency)
    this.$store.commit('UPDATE_AGENCY', response.data)
  },
})
